import { create } from "zustand";
import type { CompileResult } from "../runtime-types";

interface CompileStoreState {
  byProjectId: Record<string, CompileResult | undefined>;
  revisionByProjectId: Record<string, number>;
  globalRevision: number;
  setCompileResult: (projectId: string, result: CompileResult | undefined) => void;
  clearCompileResult: (projectId: string) => void;
  getCompileResult: (projectId: string) => CompileResult | undefined;
  getCompileRevision: (projectId: string) => number;
}

export const useIndicatorCompileStore = create<CompileStoreState>((set, get) => ({
  byProjectId: {},
  revisionByProjectId: {},
  globalRevision: 0,
  setCompileResult: (projectId, result) =>
    set((s) => {
      const next: Partial<CompileStoreState> = {
        byProjectId: { ...s.byProjectId, [projectId]: result },
      };
      if (result?.success) {
        next.revisionByProjectId = {
          ...s.revisionByProjectId,
          [projectId]: (s.revisionByProjectId[projectId] ?? 0) + 1,
        };
        next.globalRevision = s.globalRevision + 1;
      }
      return next;
    }),
  clearCompileResult: (projectId) =>
    set((s) => ({
      byProjectId: { ...s.byProjectId, [projectId]: undefined },
      revisionByProjectId: {
        ...s.revisionByProjectId,
        [projectId]: (s.revisionByProjectId[projectId] ?? 0) + 1,
      },
      globalRevision: s.globalRevision + 1,
    })),
  getCompileResult: (projectId) => get().byProjectId[projectId],
  getCompileRevision: (projectId) => get().revisionByProjectId[projectId] ?? 0,
}));
